module.exports = __webpack_public_path__ + "static/media/dum-dum-loader.33761ebb.gif";